__turbopack_context__.v({
  "component_health": "FAfCeq_component_health",
  "component_health__tag": "FAfCeq_component_health__tag",
  "component_health__tags": "FAfCeq_component_health__tags",
});
